<template>
  <PageComponents :page="page" v-if="page"/>
  <CookieComponents lang="fr"/>
</template>

<script>
// @ is an alias to /src
import dataFR from '@/assets/json/fr.json'
import PageComponents from '../components/PageComponents'
import CookieComponents from '../components/CookieComponents'

import global from '../assets/js/app.js';

export default {
    name: 'FRView',
    components: {
        PageComponents,
        CookieComponents
    },
    mounted() {
        global.init();
    },
    data() {
        return {
            page: dataFR,
        };
    }
}
</script>